import React, { useEffect, useState } from 'react';
const BUYERS = [{
  name: 'Carmen López',
  city: 'Ciudad de México'
}, {
  name: 'Rosa Martínez',
  city: 'Bogotá'
}, {
  name: 'Elena García',
  city: 'Lima'
}, {
  name: 'Patricia Sánchez',
  city: 'Buenos Aires'
}, {
  name: 'Lucía Fernández',
  city: 'Santiago'
}, {
  name: 'María Rodríguez',
  city: 'Guadalajara'
}, {
  name: 'Ana Herrera',
  city: 'Medellín'
}, {
  name: 'Sofía Ramírez',
  city: 'Quito'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showPopup, 30000);
    const interval = setInterval(() => {
      if (!isVisible) showPopup();
    }, Math.floor(Math.random() * 10000) + 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start gap-3 animate-slide-in" role="status" aria-live="polite" data-id="element-233">
      <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-234">
        <svg className="w-5 h-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true" data-id="element-235">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" data-id="element-236" />
        </svg>
      </div>
      <div data-id="element-237">
        <p className="text-sm text-gray-800 leading-tight" data-id="element-238">
          <span className="font-bold" data-id="element-239">{currentBuyer.name}</span> de{' '}
          <span className="font-semibold" data-id="element-240">{currentBuyer.city}</span> acaba de
          adquirir{' '}
          <span className="font-bold text-green-700" data-id="element-241">
            LAS 50 POMADAS MEDICINALES™
          </span>
        </p>
        <p className="text-xs text-gray-600 mt-1" data-id="element-242">Hace unos instantes</p>
      </div>
    </div>;
}